/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-undefined */
/* eslint-disable max-lines */
import { Close } from '@mui/icons-material';
import { CreateCalendarFormFieldObject } from '../../../params/redux/calendar_form_builder';
import CustomInput from '../../reusable/input';
import { FONT_FAMILIES } from '../../../helper/form_builder';
import LabelWrapper from '../../wrapper/label';
import { ALIGN_SIZE, BTN_SIZE, HEADINGS } from '../../../helper/form_builder/font_families';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, IconButton, MenuItem, Select, Slider, Typography } from '@mui/material';
import { editFormFieldInCalendarBuilder, settingSelectedCalendarFormFieldProperty } from '../../../redux/slices/calendar_form_builder';
import { useDispatch, useSelector } from 'react-redux';

const renderInputField = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    return (
        <CustomInput
            label={selectedFormField.type === 'heading' || selectedFormField.type === 'description' ? '' : selectedFormField.type === 'submit' ? 'Button Text' : 'Field Label'}
            value={selectedFormField.label}
            onChange={(e) => handleFieldChange('label', e.target.value)}
            fullWidth
        />
    );
};

const renderPlaceholderField = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    if (selectedFormField.type && !['radio', 'checkbox', 'slider', 'rating', 'date', 'image', 'file', 'submit'].includes(selectedFormField?.type)) {
        return (
            <CustomInput
                label="Placeholder"
                value={selectedFormField.placeholder || ''}
                onChange={(e) => handleFieldChange('placeholder', e.target.value)}
                fullWidth
            />
        );
    }
    return null;
};

const renderColorPicker = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    const handleChange = (value: string) => {
        handleFieldChange('labelColor', value);
    };
    return (
        <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle2" mb={1}>
                {selectedFormField.type === 'heading' || selectedFormField.type === 'description'
                    ? 'Select Color'
                    : selectedFormField.type === 'submit' ? 'Text Color' : 'Label Font Color'}
            </Typography>
            <input
                type="color"
                value={selectedFormField.labelColor}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    padding: 0,
                    background: 'none',
                    cursor: 'pointer'
                }}
            />
        </Box>
    );
};

const renderBgColorPicker = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    const handleChange = (value: string) => {
        handleFieldChange('bgColor', value);
    };
    return (
        <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="subtitle2" mb={1}>
                Button Background Color
            </Typography>
            <input
                type="color"
                value={selectedFormField.bgColor as string}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    padding: 0,
                    background: 'none',
                    cursor: 'pointer'
                }}
            />
        </Box>
    );
};

const renderFontSelection = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    if (selectedFormField.type !== 'submit') {
        return (
            <Box>
                <Typography gutterBottom>Font Family</Typography>
                <Select
                    value={selectedFormField.fontFamily || 'Arial, sans-serif'}
                    onChange={(e) => handleFieldChange('fontFamily', e.target.value)}
                    fullWidth
                >
                    {FONT_FAMILIES.map((font, index) => (
                        <MenuItem key={index} value={font.value} style={{ fontFamily: font.value }}>
                            {font.label}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        );
    }
    return null;
};

const renderBtnSizeSelection = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    return (
        <Box>
            <Typography gutterBottom>Button Size</Typography>
            <Select
                value={selectedFormField.btnSize || 'small'}
                onChange={(e) => handleFieldChange('btnSize', e.target.value)}
                fullWidth
            >
                {BTN_SIZE.map((font, index) => (
                    <MenuItem key={index} value={font.value}>
                        {font.label}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};

const renderBtnAlignSelection = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    return (
        <Box>
            <Typography gutterBottom>Button Alignment</Typography>
            <Select
                value={selectedFormField.btnAlign || 'left'}
                onChange={(e) => handleFieldChange('btnAlign', e.target.value)}
                fullWidth
            >
                {ALIGN_SIZE.map((font, index) => (
                    <MenuItem key={index} value={font.value}>
                        {font.label}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};

const renderHeaderSelection = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    if (selectedFormField.type !== 'submit') {
        return (
            <Box>
                <Typography gutterBottom>Heading Size</Typography>
                <Select
                    value={selectedFormField.heading_size || 'h1'}
                    onChange={(e) => handleFieldChange('heading_size', e.target.value)}
                    fullWidth
                >
                    {HEADINGS.map((font, index) => (
                        <MenuItem key={index} value={font.value}>
                            {font.label}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        );
    }
    return null;
};

const renderSliderOptions = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    if (selectedFormField.type === 'slider') {
        return (
            <Box className="flex flex-col gap-4 mt-4">
                <CustomInput
                    label="Maximum Value"
                    type="number"
                    value={selectedFormField.max ?? 0}
                    onChange={(e) => handleFieldChange('max', parseInt(e.target.value, 10))}
                    error={
                        selectedFormField.max !== undefined &&
                        selectedFormField.min !== undefined &&
                        selectedFormField.max <= selectedFormField.min
                    }
                    helperText={
                        selectedFormField.max !== undefined &&
                            selectedFormField.min !== undefined &&
                            selectedFormField.max <= selectedFormField.min
                            ? 'Maximum value must be greater than minimum value'
                            : ''
                    }
                    fullWidth
                />
            </Box>
        );
    }
    return null;
};

const renderRatingOptions = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    if (selectedFormField.type === 'rating') {
        return (
            <><CustomInput
                label="Maximum Stars"
                type="number"
                value={selectedFormField.maxStars ?? 0}
                onChange={(e) => handleFieldChange('maxStars', parseInt(e.target.value, 10))}
                error={
                    selectedFormField.maxStars
                        ? selectedFormField.maxStars < 1 || selectedFormField.maxStars > 10
                        : false
                }
                helperText={
                    selectedFormField.maxStars
                        ? selectedFormField.maxStars < 1
                            ? 'Minimum 1 star required'
                            : selectedFormField.maxStars > 10
                                ? 'Maximum 10 stars allowed'
                                : ''
                        : ''
                }
                fullWidth
            />
                <CustomInput
                    label="Minimum Value"
                    type="number"
                    value={selectedFormField.min ?? 0}
                    onChange={(e) => handleFieldChange('min', parseInt(e.target.value, 10))}
                    fullWidth
                />
                <CustomInput
                    label="Step Size"
                    type="number"
                    value={typeof (selectedFormField.step) === 'number' ? selectedFormField.step : 1}
                    onChange={(e) => handleFieldChange('step', parseFloat(e.target.value))}
                    fullWidth
                />
            </>
        );
    }
    return null;
};

const renderCheckboxRadioOptions = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => {
    if (selectedFormField.type !== 'checkbox' && selectedFormField.type !== 'radio') {
        return null;
    }

    // Ensure `options` is an array and set default labels
    const currentOptions: string[] = Array.isArray(selectedFormField.options) ? [...selectedFormField.options] : [];
    const optionCount = typeof selectedFormField.optionCount === 'number' ? selectedFormField.optionCount : 1;

    const handleSliderChange = (event: Event, value: number | number[]) => {
        if (typeof value === 'number') {
            let newOptions = [...currentOptions];

            if (value > newOptions.length) {
                // Add missing options with default labels
                for (let i = newOptions.length; i < value; i++) {
                    newOptions.push(`Option ${i + 1}`);
                }
            } else if (value < newOptions.length) {
                // Remove extra options
                newOptions = newOptions.slice(0, value);
            }

            handleFieldChange('optionCount', value);
            handleFieldChange('options', newOptions);
        }
    };

    return (
        <Box>
            <Typography gutterBottom>Number of Options</Typography>
            <Slider
                value={optionCount}
                onChange={handleSliderChange}
                min={1}
                max={10}
                marks
                step={1}
            />
            <Box display="flex" flexDirection="column" gap={1}>
                <LabelWrapper label="Options Label" />
                {currentOptions.map((option, index) => (
                    <CustomInput
                        key={index}
                        value={option}
                        onChange={(e) => {
                            const updatedOptions = [...currentOptions];
                            updatedOptions[index] = e.target.value;
                            handleFieldChange('options', updatedOptions);
                        }}
                        fullWidth
                    />
                ))}
            </Box>
        </Box>
    );
};

const renderRequiredCheckbox = (selectedFormField: CreateCalendarFormFieldObject, handleFieldChange: (key: string, value: any) => void) => (
    <CustomInput
        type="checkbox"
        label="Required"
        checked={selectedFormField.default ? true : selectedFormField.required ?? false}
        disabled={selectedFormField.default as boolean}
        onChange={() => handleFieldChange('required', !selectedFormField.required)}
    />
);

const SelectedCalendarFieldProperty = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedFormField } = useSelector((state: RootState) => state.calendarformbuilder);

    if (!selectedFormField) return <></>;

    const handleFieldChange = (fieldKey: string, value: any) => {
        dispatch(editFormFieldInCalendarBuilder({ [fieldKey]: value }));
    };

    const closePropertyField = () => {
        dispatch(settingSelectedCalendarFormFieldProperty(null));
    };

    return (
        <>
            <Box width="100%" display="flex" flexDirection="column" gap={1}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5">Properties</Typography>
                    <IconButton onClick={closePropertyField}>
                        <Close />
                    </IconButton>
                </Box>
                <Typography variant="subtitle1" fontWeight="bold">
                    {selectedFormField.type?.toUpperCase()}
                </Typography>
                {renderInputField(selectedFormField, handleFieldChange)}
                {selectedFormField.type !== 'heading' && selectedFormField.type !== 'description' && selectedFormField.type !== 'submit' && renderPlaceholderField(selectedFormField, handleFieldChange)}
                {selectedFormField.type === 'heading' && renderHeaderSelection(selectedFormField, handleFieldChange)}
                {renderColorPicker(selectedFormField, handleFieldChange)}
                {selectedFormField.type === 'submit' && renderBgColorPicker(selectedFormField, handleFieldChange)}
                {selectedFormField.type === 'submit' && renderBtnAlignSelection(selectedFormField, handleFieldChange)}
                {selectedFormField.type === 'submit' && renderBtnSizeSelection(selectedFormField, handleFieldChange)}
                {selectedFormField.type !== 'submit' && renderFontSelection(selectedFormField, handleFieldChange)}
                {selectedFormField.type !== 'submit' && renderSliderOptions(selectedFormField, handleFieldChange)}
                {selectedFormField.type !== 'submit' && renderRatingOptions(selectedFormField, handleFieldChange)}
                {selectedFormField.type !== 'submit' && renderCheckboxRadioOptions(selectedFormField, handleFieldChange)}
                {selectedFormField.type !== 'heading' && selectedFormField.type !== 'description' && selectedFormField.type !== 'submit' && !selectedFormField.default && renderRequiredCheckbox(selectedFormField, handleFieldChange)}
            </Box>
        </>
    );
};

export default SelectedCalendarFieldProperty;